import { useEffect, useState } from "react";
import {
  formatPhoneNumberIntl,
  isPossiblePhoneNumber,
  getCountryCallingCode,
} from "react-phone-number-input";
import { FormHelperText, TextField } from "@mui/material";

const defaultCountry = "US";
const defaultCountryCode = `+${getCountryCallingCode(defaultCountry)}`;

export default function MUIPhoneInput(props) {
  const { value, onChange, onBlur, ...rest } = props;
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!props.value || props.value === "") {
      onChange({
        target: {
          name: props.name,
          value: defaultCountryCode,
        },
      });
    }
    // eslint-disable-next-line
  }, []);

  const handleChanges = (e, blur) => {
    if (isPossiblePhoneNumber(e.target.value)) {
      e.target.value = formatPhoneNumberIntl(e.target.value);
      setError(null);
    } else {
      if (e.target.value?.[0] && e.target.value?.[0] !== "+") {
        setError(
          "Invalid phone number. Please enter an international area code"
        );
      } else if (blur || error) {
        setError("Invalid phone number");
      }
    }
  };

  const handleChange = (e) => {
    if (onChange) {
      handleChanges(e);
      onChange(e);
    }
  };
  const handleBlur = (e) => {
    if (onBlur) {
      handleChanges(e, true);
      onBlur(e);
    }
  };
  return (
    <>
      <TextField
        {...rest}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {error && <FormHelperText error>{error}</FormHelperText>}
    </>
  );
}
